var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86316 0H16.0337V13.1032H13.7432V4.04211L1.78526 16L0 14.2484L11.9579 2.29053H2.86316V0Z",
    fill: "#D5AC7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGold);
export default __webpack_public_path__ + "static/media/arrow-gold.bd521e3f0421a10cc22571dc789502e6.svg";
export { ForwardRef as ReactComponent };